import { render, staticRenderFns } from "./KnownForDetail.vue?vue&type=template&id=79b70d4e&scoped=true&"
import script from "./KnownForDetail.vue?vue&type=script&lang=js&"
export * from "./KnownForDetail.vue?vue&type=script&lang=js&"
import style0 from "./KnownForDetail.vue?vue&type=style&index=0&id=79b70d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b70d4e",
  null
  
)

export default component.exports